import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/author/_author/doctoral-committee/_doctoralCommittee')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.doctoralCommittees' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
